import { render, staticRenderFns } from "./EditPayment.vue?vue&type=template&id=980165a0"
import script from "./EditPayment.vue?vue&type=script&lang=js"
export * from "./EditPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports